import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Carousel from 'components/common/Carousel'
import EducationalMaterialsItem from './components/EducationalMaterialsItem'
import { CustomPlayPauseButton } from './components/CustomPlayPauseButton'
import { CUSTOM_PLAY_PAUSE_BUTTON_CLASS } from '../../constants'

const MyGarageEducationContentDetails = ({
  educationalMaterials,
  carouselConfig,
  totalItemsCount,
  setTogglePlayPause,
  togglePlayPause,
  setIsPlaying,
  isPlaying
}) =>
  <Container>
    <CarouselWrapper
      config={ carouselConfig }
      pausedByDefault
      setTogglePlayPauseForParent={ setTogglePlayPause }
      setIsPlayingParent={ setIsPlaying } >
      {educationalMaterials.map((item, index) => (
        <EducationalMaterialsItem
          key={ item.title }
          totalItemsCount={ totalItemsCount }
          itemNumber={ index + 1 }
          item={ item } />
      ))}
    </CarouselWrapper>

    <CustomPlayPauseButton togglePlayPause={ togglePlayPause } isPlaying={ isPlaying } />
  </Container >

MyGarageEducationContentDetails.propTypes = {
  carouselConfig: PropTypes.shape(),
  educationalMaterials: PropTypes.arrayOf(PropTypes.shape()),
  isPlaying: PropTypes.bool,
  setIsPlaying: PropTypes.func,
  setTogglePlayPause: PropTypes.func,
  togglePlayPause: PropTypes.func,
  totalItemsCount: PropTypes.number
}

export default MyGarageEducationContentDetails

const Container = styled.div`
  grid-area: EducationalMaterials;
  position: relative;
  border-radius: 4px;
  overflow: hidden;

  .${CUSTOM_PLAY_PAUSE_BUTTON_CLASS} {
    position: absolute;
    right: 10px;
    bottom: 10px;
    ${Media.mobile`
      bottom: 10px;
    `}
  }

  .default-play-pause-button {
    display: none;
  }
`

const CarouselWrapper = styled(Carousel)`
  .slick-track {
    background-color: ${Theme.colors.blue};

    .slick-slide:not(.slick-active) {
      visibility: hidden;
    }
  }

  .slick-dots {
    bottom: 18px;
    left: 50%;
    transform: translateX(-50%);
    ${Media.mobile`
      right: unset;
      bottom: 10px;
    `}

    .slick-active {
      [data-at-carousel-dot-button] {
        opacity: 1;
      }
    }

    [data-at-carousel-dot-button] {
      width: 8px;
      height: 8px;
      background-color: ${Theme.colors.white};
      cursor: pointer;
      opacity: 0.5;
    }
  }
`
